import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Generic floating action button to redirect artists to a creation flow.
 * Hidden for non-artists.
 */
export const ArtistCreateRedirectFab = ({ to, label = "Creer", testId }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user || user.role !== "artist") return null;

  return (
    <button
      onClick={() => navigate(to)}
      className="fixed bottom-24 right-4 z-40 bg-gradient-to-r from-[#FF6B35] to-[#7000FF] text-white font-bold rounded-full shadow-2xl hover:scale-105 active:scale-95 transition-transform flex items-center gap-2 px-5 py-3.5"
      data-testid={testId || "create-redirect-fab"}
      aria-label={label}
    >
      <Plus className="w-5 h-5" />
      <span className="text-sm">{label}</span>
    </button>
  );
};
